import * as PropTypes from 'prop-types';
/**
 * @hidden
 */
export var toIconName = function (iconClass) { return iconClass.replace(/^k-i-/, ''); };
/**
 * @hidden
 */
export var toIconClass = function (name) { return 'k-i-' + name; };
/**
 * @hidden
 */
export var svgIconPropType = PropTypes.shape({
    name: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    viewBox: PropTypes.string.isRequired
});
